import React from 'react';
import './LoadingSpinner.scss';

const LoadingSpinner = ({ size = 'medium', color = '#3498db' }) => {
  return (
    <div className={`loading-spinner loading-spinner--${size}`}>
      <div
        className="loading-spinner__circle"
        style={{ borderTopColor: color }}
      ></div>
    </div>
  );
};

export default LoadingSpinner;